const STUDENT_TABLE = {
  getStatusClassBox(status) {
    status = (status || "").toLowerCase();

    if (status === "withdrawal") {
      return "danger-box";
    }

    if (status === "studying") {
      return "warning-box";
    }

    return "success-box";
  },
  generateStatusColHTML(status) {
    if (!status) return "";

    const statusClassBox = this.getStatusClassBox(status);
    return `<p class="rounded-[40px] py-[5px] px-[15px] uppercase font-medium text-base w-max ${statusClassBox}">${status}</p>`;
  }
};

export { STUDENT_TABLE };
